exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-item-title[data-v-78fad739]{border-radius:0 0 5px 5px}.tab-item-img[data-v-78fad739]{border-radius:5px 5px 0 0}[data-v-78fad739] .el-form-item__content{margin-right:30px!important;margin-left:80px!important}[data-v-78fad739] .el-loading-mask{background-color:rgba(0,0,0,.5)!important}", ""]);

// exports
